export default __webpack_public_path__ + "static/media/logo-black.91914f58.png";